import React from "react";

const NotFound = () => {
  return (
    <div>
      <h2 style={{ textAlign: "center", fontSize: "40px" }}>404</h2>
      <h4 style={{ textAlign: "center" }}>Page not found!</h4>
    </div>
  );
};

export default NotFound;
